var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-table',{attrs:{"flat":"","data":_vm.data,"columns":_vm.columns,"loading":_vm.loading,"pagination":_vm.quasarPagination}})
}
var staticRenderFns = []

export { render, staticRenderFns }